import { ReactNode, createContext, useState } from "react";
import { Alert, AlertColor, IconButton } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";

const SnackbarContext = createContext({
  createSnackbar: (message: string, color: AlertColor) => {}, // Default function
});

interface RenderSnackProps {
  message: string;
  open: boolean;
  color: AlertColor;
  handleClose: () => void;
}

interface SnackProviderProps {
  children: ReactNode;
}

interface Snack {
  message: string;
  open: boolean;
  color: AlertColor;
}

function RenderSnack({ message, open, color, handleClose }: RenderSnackProps) {
  return (
    <Snackbar
      open={open}
      action={[
        <IconButton key="close" aria-label="Close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>,
      ]}
    >
      <Alert
        onClose={handleClose}
        severity={color}
        variant="filled"
        style={{ minWidth: "250px" }}
        sx={{ width: "100%" }}
      >
        <span>{message}</span>
      </Alert>
    </Snackbar>
  );
}

export const SnackProvider = ({ children }: SnackProviderProps) => {
  const [current, setCurrent] = useState<Snack | null>(null);

  function createSnackbar(message: string, color: AlertColor) {
    const snack: Snack = { message, open: true, color };

    setCurrent(snack);
  }

  const handleClose = () => setCurrent(null);

  return (
    <SnackbarContext.Provider value={{ createSnackbar }}>
      {current && <RenderSnack {...current} handleClose={handleClose} />}
      {children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarContext;
